import { FacadeSymbolRates } from './store-facades';

export const moduleApi = ($store) => {
  const facadeSymbolRates = new FacadeSymbolRates($store);

  return {
    fetchCurrentRates: facadeSymbolRates.fetchCurrentRates.bind(facadeSymbolRates),
  };
};
